import schemeApi from '../schemes/schemeApi';
let {routeAnalyticsClients} = schemeApi;
/**
 *
 * @property {array} settingsItems - элементы настроек
 */
let schemeSlicesClients = {
    client: {
        title: 'Клиенты',
        header: 'Клиент',
        route: routeAnalyticsClients
    },
    // brand: {
    //     title: 'Бренды',
    //     header: 'Бренд',
    //     route: routeAnalyticsBrands
    // },
}

export default schemeSlicesClients;